import { ImageDTOApi } from "../Image/ImageDTO";
import { ResourceResponseApi } from "../ServerResponseType/Resource/Resource";

export interface ResourceRequestApi {
  resourceFile?: ImageDTOApi;
  resource: ResourceResponseApi & {
    resourceLink?: string;
    resourceFormat: string;
    resourceIsDownloadable: boolean;
  };
}

export class ResourceRequestImpl implements ResourceRequestApi {
  resourceFile?: ImageDTOApi;
  resource: ResourceResponseApi & {
    resourceLink?: string;
    resourceFormat: string;
    resourceIsDownloadable: boolean;
  };

  constructor(
    resource: ResourceResponseApi,
    resourceFileData: {
      resourceFile?: ImageDTOApi;
      resourceLink?: string;
      resourceFormat: string;
      resourceIsDownloadable: boolean;
    }
  ) {
    this.resourceFile = resourceFileData.resourceFile;
    this.resource = {
      ...resource,
      resourceLink: resourceFileData.resourceLink,
      resourceFormat: resourceFileData.resourceFormat,
      resourceIsDownloadable: resourceFileData.resourceIsDownloadable,
    };
  }
}
